module.exports = __webpack_public_path__ + "img/146.a5fcd78d.jpg";